export default __webpack_public_path__ + "static/share-f8101baebbe5cbbfab87749a2e3217a1.jpg";